import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import Tooltip from "@mui/material/Tooltip";
import ItineraryModal from "components/form/ItineraryModal";
import React, { useState, useContext } from "react";
import { SidebarContext } from "context/SidebarContext";
import { FiFile, FiZoomIn } from "react-icons/fi";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import { MdClose } from "react-icons/md";
import { notifyError, notifySuccess } from "utils/toast";
import TripadvanceServices from "services/TripadvanceServices";
import ApproveModal from "components/modal/ApproveModal";
const TripadvanceTable = ({
  tripadvance,
  perpage,
  currentPage,
  tab,
  hideEdit,
}) => {
  const [showItineraryModal, setShowItineraryModal] = useState(false);
  const [retrictedAmount, setRetrictedAmount] = useState(0);
  const [selectedTripadvance, setSelectedTripadvance] = useState(null);
  const [selectedTripadvanceId, setSelectedTripadvanceId] = useState(0);
  const { setIsUpdate } = useContext(SidebarContext);
  const [isRemarkModalOpen, setIsRemarkModalOpen] = useState(false);
  const [itinerary, setItinerary] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState("");

  const handleModalAction = async (action, remark) => {
    try {
      const payload = {
        status: action === "approve" ? 1 : 2,
      };

      if (action === "reject") {
        payload.approved_remark = remark || "Rejected";
      }

      payload.approved_amount = selectedTripadvance;
      const response = await TripadvanceServices.tripadvanceStatus(
        selectedTripadvanceId,
        payload,
      );

      if (response.status) {
        setIsUpdate(true);
        notifySuccess(response.message);
      } else {
        // console.log(response)
        notifyError(response.message);
      }
    } catch (error) {
      if (error.response?.data?.message) {
        notifyError(error.response.data.message);
      } else {
        notifyError("Error updating status.");
      }
    } finally {
      setIsRemarkModalOpen(false);
    }
  };

  const handleClose = () => setOpen(false);
  const handleOpen = (data) => {
    // console.log(data);
    setOpen(true);
    setSelectedRemark(
      <div>
        <strong>Remarks:</strong>
        <ul>
          {Array.isArray(data) && data.length > 0 ? (
            data.map((item, j) =>
              item && item.date && item.remark ? (
                <li key={j}>
                  {item.date} - {item.remark}
                </li>
              ) : null,
            )
          ) : (
            <li>No remarks</li>
          )}
        </ul>
      </div>,
    );
  };

  const getDisplayStatusColor = (displayStatus) => {
    switch (displayStatus) {
      case "Paid":
        return "text-green-600 font-semibold";
      case "Awaiting for Payment":
        return "text-orange-500 font-semibold";
      case "Awaiting for Approval":
        return "text-red-600 font-semibold";
      case "Partially Paid":
        return "text-blue-600 font-semibold";
      default:
        return "text-gray-600 font-semibold";
    }
  };

  const displayStatusByIndex = (data, index) => {
    return data?.status?.[index] ?? data?.approval_status?.[index] ?? "";
  };

  return (
    <>
      <ApproveModal
        isOpen={isRemarkModalOpen}
        onClose={() => setIsRemarkModalOpen(false)}
        title="Approve / Reject"
        onYesClick={(remark) => handleModalAction("approve", remark)}
        onRejectClick={(remark) => handleModalAction("reject", remark)}
        data={selectedTripadvance}
        retrictedAmount={retrictedAmount}
      />

      <ItineraryModal
        isOpen={showItineraryModal}
        content={itinerary}
        onClose={() => setShowItineraryModal(false)}
      />

      <TableBody>
        {tripadvance.slice(0, perpage).map((data, index) => {
          const advances = data.trip_advances ?? [];

          return (
            <TableRow
              key={data.id || index}
              className={
                data.booking_status === 1
                  ? "text-center bg-red-100 dark:bg-gray-500"
                  : "text-center"
              }
            >
              <TableCell className="text-center text-sm">
                {(currentPage - 1) * perpage + index + 1}
              </TableCell>
              <TableCell className="text-sm">
                {data.ref_no}
                {/* {console.log(groupedArray)} */}
              </TableCell>

              <TableCell className="text-sm">{data.client_name}</TableCell>
              <TableCell className="text-sm">
                <div className="flex flex-col row-gap-4 text-sm">
                  <p className="m-0">{data.start_date}</p>

                  <p className="m-0">{data.end_date}</p>
                </div>
              </TableCell>

              <TableCell className="text-sm">
                <div className="flex flex-col row-gap-4 text-sm">
                  <p className="m-0">{data.arrival}</p>

                  <p className="m-0">{data.departure}</p>
                </div>
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.no_of_days}
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.vehicle_type}
              </TableCell>
              {tab === 0 && (
                <TableCell>
                  {data.itinerary && (
                    <div
                      className="flex flex-col items-center justify-center text-green-600 cursor-pointer"
                      onClick={() => {
                        setShowItineraryModal(true);
                        setItinerary(data.itinerary);
                      }}
                      title="Itinerary"
                    >
                      <FiFile size={"25px"} />
                    </div>
                  )}
                </TableCell>
              )}

              <TableCell className="text-sm text-center">
                {data.vendor_name}
              </TableCell>
              <TableCell className="text-sm ">
                <p>{data.va_start_date}</p>
                <p>{data.va_end_date}</p>
              </TableCell>

              <TableCell>
                {advances
                  .slice()
                  .reverse()
                  .map((item) => (
                    <div key={item.id} className="mb-4">
                      {item.trip_advance_request}

                      {item.approval_status === "Re-Request" &&
                        item.rerequest_remark && (
                          <button
                            onClick={() => handleOpen(item.rerequest_remark)}
                            className="px-3 py-2 cursor-pointer text-gray-400 hover:text-green-600"
                          >
                            <FiZoomIn />
                          </button>
                        )}
                    </div>
                  ))}
              </TableCell>

              {tab === 0 && (
                <TableCell className="text-center">
                  {advances
                    ?.slice()
                    .reverse()
                    .map((item, index) => {
                      const displayStatus = item.status;

                      const getColorClass = (status) => {
                        switch (status) {
                          case "Approved":
                            return "text-green-600 font-semibold";
                          case "Rejected":
                            return "text-red-600 font-semibold cursor-pointer";
                          case "Paid":
                            return "text-blue-600 font-semibold cursor-pointer";
                          case "Partially Paid":
                            return "text-blue-600 font-semibold";
                          case "Awaiting for Payment":
                            return "text-orange-500 font-semibold";
                          case "Awaiting for Approval":
                            return "text-red-600 font-semibold";
                          default:
                            return "text-gray-600 font-semibold";
                        }
                      };

                      return (
                        // <div className="mb-4" key={item.id || index}>
                        //   {data.booking_status !== 1 &&
                        //     (item.approval_status === "Pending" ||
                        //     item.approval_status === "Re-Request" ? (
                        //       <button
                        //         className="text-sm px-3 py-1 rounded bg-yellow-500 text-white"
                        //         onClick={() => {
                        //           setSelectedTripadvance(
                        //             item.trip_advance_request,
                        //           );
                        //           setRetrictedAmount(item.restrict_amount);
                        //           setSelectedTripadvanceId(item.id);
                        //           setIsRemarkModalOpen(true);
                        //         }}
                        //       >
                        //         Pending
                        //       </button>
                        //     ) : (
                        //       <span
                        //         className={`text-sm px-3 py-1 rounded ${getColorClass(
                        //           displayStatus,
                        //         )}`}
                        //       >
                        //         {displayStatus}

                        //       </span>
                        //     ))}
                        // </div>
                        <div className="mb-4" key={item.id || index}>
                          {data.booking_status !== 1 &&
                            (data.is_current === false ? (
                              <span className="text-orange-500 font-semibold">
                                Vendor has been changed
                              </span>
                            ) : item.approval_status === "Pending" ||
                              item.approval_status === "Re-Request" ? (
                              hideEdit ? (
                                <button
                                  className="text-sm px-3 py-1 rounded bg-yellow-500 text-white"
                                  onClick={() => {
                                    setSelectedTripadvance(
                                      item.trip_advance_request,
                                    );
                                    setRetrictedAmount(data.restrict_amount);
                                    setSelectedTripadvanceId(item.id);
                                    setIsRemarkModalOpen(true);
                                  }}
                                >
                                  Pending
                                </button>
                              ) : (
                                <span>-</span>
                              )
                            ) : (
                              <span
                                className={`text-sm px-3 py-1 rounded ${getColorClass(
                                  displayStatus,
                                )}`}
                              >
                                {displayStatus}
                              </span>
                            ))}
                        </div>
                      );
                    })}
                </TableCell>
              )}

              {tab === 1 && (
                <TableCell>
                  {advances
                    ?.slice()
                    .reverse()
                    .map((item, i) => {
                      const request = item.approval_status;
                      const displayStatus = item.status;
                      const isPaidValid =
                        item.trip_advance_paid &&
                        Number(item.trip_advance_paid) !== 0;

                      const getColorClass = (status) => {
                        switch (status) {
                          case "Approved":
                            return "text-green-600 font-semibold";
                          case "Rejected":
                            return "text-red-600 font-semibold cursor-pointer";
                          case "Pending":
                            return "text-yellow-600 font-semibold";
                          case "Re-Request":
                            return "text-yellow-600 font-semibold";
                          case "Paid":
                            return "text-blue-600 font-semibold cursor-pointer";
                          default:
                            return "text-gray-600";
                        }
                      };

                      const tooltipContent = () => {
                        if (request === "Paid" && isPaidValid) {
                          return (
                            <>
                              <p>
                                <strong>Amount:</strong> ₹
                                {item.trip_advance_paid}
                              </p>
                              <p>
                                <strong>Payment Type:</strong>{" "}
                                {item.payment_type}
                              </p>
                              <p>
                                <strong>Date:</strong> {item.paid_date}
                              </p>
                              <p>
                                <strong>UTR:</strong> {item.utr}
                              </p>
                              <p>
                                <strong>Remark:</strong> {item.paid_remark}
                              </p>
                            </>
                          );
                        } else if (request === "Rejected") {
                          return (
                            <div>
                              <strong>Remarks:</strong>
                              <ul>
                                {Array.isArray(item.approved_remark) &&
                                item.approved_remark.length > 0 ? (
                                  item.approved_remark.map((remark, j) =>
                                    remark && remark.date && remark.remark ? (
                                      <li key={j}>
                                        {remark.date} - {remark.remark}
                                      </li>
                                    ) : null,
                                  )
                                ) : (
                                  <li>No remarks</li>
                                )}
                              </ul>
                            </div>
                          );
                        } else if (request === "Re-Request") {
                          return (
                            <div>
                              <strong>Remarks:</strong>
                              <ul>
                                {Array.isArray(item.rerequest_remark) &&
                                item.rerequest_remark.length > 0 ? (
                                  item.rerequest_remark.map((remark, j) =>
                                    remark && remark.date && remark.remark ? (
                                      <li key={j}>
                                        {remark.date} - {remark.remark}
                                      </li>
                                    ) : null,
                                  )
                                ) : (
                                  <li>No remarks</li>
                                )}
                              </ul>
                            </div>
                          );
                        }

                        return null;
                      };

                      const content = (
                        <span
                          className={
                            request === "Approved" || request === "Re-Request"
                              ? getDisplayStatusColor(displayStatus)
                              : getColorClass(request)
                          }
                        >
                          {/* {request === "Approved" || request === "Re-Request"
                            ? displayStatus
                            : request} */}
                          {displayStatus}
                        </span>
                      );

                      return (
                        <div key={item.id || i} className="mb-4">
                          {(request === "Paid" && isPaidValid) ||
                          request === "Re-Request" ||
                          request === "Rejected" ? (
                            <Tooltip
                              title={tooltipContent()}
                              placement="top-start"
                              arrow
                            >
                              {content}
                            </Tooltip>
                          ) : (
                            content
                          )}
                        </div>
                      );
                    })}
                </TableCell>
              )}
            </TableRow>
          );
        })}
      </TableBody>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 300,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
          }}
        >
          {/* Close Icon */}
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <MdClose size={24} />
          </IconButton>

          <Typography variant="body1" sx={{ mt: 4 }}>
            {selectedRemark}
          </Typography>
        </Box>
      </Modal>
    </>
  );
};

export default TripadvanceTable;
